import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CircularProgress,
  Container,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Stack,
  Typography,
} from '@mui/material';
import Iconify from '../components/iconify';
import UploadButton from '../components/UploadButton';
import {
  createBlobInContainer,
  deleteBlobIfItExists,
  getBlobsInContainer,
} from 'src/api/filesApi';

export default function ImageLibraryPage() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState<{ blobUrl: string; blobName: string }[]>(
    []
  );

  useEffect(() => {
    const fetchImages = async () => {
      await getContainerImages();
    };

    fetchImages().catch(console.error);
  }, []);
  const getContainerImages = async () => {
    const data = await getBlobsInContainer();
    console.log('data', data);
    setImages(data);
  };
  const deleteImageHandler = async (value: any) => {
    await deleteBlobIfItExists(value);
    window.location.reload();
  };
  const uploadFiles = (event: any) => {
    if (event.target.files.length > 0) {
      setLoading(true);
      const files = event.target.files;
      let uploadPromises = [];
      for (let i = 0; i < files.length; i++) {
        uploadPromises.push(createBlobInContainer(files[i]));
      }
      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);
          await getContainerImages();
          setLoading(false);
        };

        uploadFiles().catch(console.error);
      }
    }
  };
  return (
    <>
      <Helmet>
        <title> Image Library </title>
      </Helmet>

      <Container>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
        >
          <Typography variant='h4' gutterBottom>
            Image Library
          </Typography>
          <UploadButton onUpload={uploadFiles} />
        </Stack>

        <Card sx={{ p: 2 }}>
          {images === null || loading ? (
            <Box
              sx={{ display: 'flex', justifyContent: 'center' }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <ImageList cols={4} rowHeight={164}>
              {images.map((item, index: number) => (
                <ImageListItem key={index}>
                  <img
                    src={item.blobUrl}
                    srcSet={item.blobUrl}
                    alt='library'
                    loading='lazy'
                  />
                  <ImageListItemBar
                    title={item.blobName}
                    subtitle={''}
                    actionIcon={
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${item.blobName}`}
                        value={item.blobName}
                        onClick={() => {
                          deleteImageHandler(item.blobName);
                        }}
                      >
                        <Iconify icon='eva:trash-2-outline' />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </Card>
      </Container>
    </>
  );
}
